<template>
    <div class="modal modal-client-create fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
          <div class="modal-content">

            <div class="modal-header">
                <h2 class="drawer-title">
                    {{title}}
                </h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div><!-- /.drawer-heading -->

            <div class="modal-body">
                <div class="mb-3">
                  <label class="control-label">Legal Company Name</label>
                  <input
                    name="company_name"
                    v-model="editClient.company"
                    type="text"
                    class="form-control"
                    data-vv-validate-on="input|blur"
                    data-vv-as="company name"
                    v-validate="'required'"
                  />

                  <help-block field="company_name"/>
                </div><!-- /.form-group -->

                <div class="mb-3">
                  <label class="control-label">Display Name</label>
                  <input
                    name="company_name"
                    v-model="editClient.display_name"
                    type="text"
                    class="form-control"
                    data-vv-validate-on="input|blur"
                    data-vv-as="display name"
                    v-validate="'required'"
                  />

                  <help-block field="display_name"/>
                </div><!-- /.form-group -->
<br><br><br>
                <h4>Primary Contact</h4>
                <hr>
                <div class="mb-3">
                  <label class="control-label">First Name</label>
                    <input
                      name="first_name"
                      v-model="editClient.first_name"
                      type="text"
                      class="form-control"
                      data-vv-validate-on="input|blur"
                      data-vv-as="first name"
                      v-validate="'required'"
                    />

                  <help-block field="first_name"/>
                </div><!-- /.form-group -->

                <div class="mb-3">
                    <label class="control-label">Surname</label>
                    <input
                      name="surname"
                      v-model="editClient.surname"
                      type="text"
                      class="form-control"
                      data-vv-validate-on="input|blur"
                      data-vv-as="surname"
                      v-validate="'required'"
                    />

                    <help-block field="surname"/>
                </div><!-- /.form-group -->

                <div class="mb-3">
                    <label class="control-label">Email</label>
                    <input
                      name="email"
                      v-model="editClient.email"
                      type="text"
                      class="form-control"
                      data-vv-validate-on="input|blur"
                      v-validate="'required|email'"
                    />

                  <help-block field="email"/>
                </div><!-- /.form-group -->

                <div class="mb-3">
                    <label class="control-label">Phone</label>
                      <input
                        name="phone"
                        v-model="editClient.phone"
                        type="text"
                        class="form-control"
                      />

                  <help-block field="phone"/>
                </div><!-- /.form-group -->

                <div class="mb-3">
                  <label class="control-label">Mobile</label>
                  <input
                    name="mobile"
                    v-model="editClient.mobile"
                    type="text"
                    class="form-control"
                  />

                  <help-block field="mobile"/>
                </div><!-- /.form-group -->

                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal">Cancel</button>
                  <c-button @click="click">Save</c-button>
                </div><!-- /.modal-footer -->

            </div><!-- /.drawer-body -->
          </div>
        </div><!-- /.drawer-contents -->
    </div><!-- /.drawer -->

</template>

<style>
    .form-control {
        box-shadow: none !important;
    }

    .form-control[readonly] {
        background-color: transparent !important;
    }
</style>

<script>

    import { mapActions, mapState } from 'vuex'
    import { http } from 'utils'
    import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
    import $ from 'jquery'
    import { notify } from 'utils'
    import { unset, cloneDeep } from 'lodash'
    import moment from 'moment'
    import Multiselect from 'vue-multiselect'
    import { helperComputed, helperMethods } from 'vx/modules/clients'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },
        props: ['title', 'client'],
        extends: CModal,
        components: {
            Selectize,
            LaddaButton,
            Datepicker,
            Multiselect
        },

        data() {
            return {
                editClient: {},
            }
        },


        mounted() {

            this.editClient = cloneDeep(this.client)

        },

        computed: {

        },


        methods: {
          ...helperMethods,

            async click() {
                if (!await this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return Promise.reject()
                }

                let payload = Object.assign(this.editClient);

                return this.storeClient(payload).then((response) => {

                  //close side drawer
                  notify.success('Client successfully created.')

                  this.$emit('created', response.id);

                  this.$bus.$emit('newClientCreated', response.id)

                  this.close()
                }).catch((error) => {
                    if (error.response && error.response.status === 422) {
                      notify.error('Form validation failed, please check your inputs and try again.')
                    } else {
                      notify.error('Failed to create client, please try again.')
                    }
                })
            }
        }
    }
</script>
